import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const useKeyDatesConfig = () => {
    const { t } = useTranslation();
    
    return useMemo(() => [
        {
            name: t("date-of-birth"),
            key: "birthDate",
        },
        {
            name: t("original-hire-date"),
            key: "hiringDate",
        },
        {
            name: t("last-hire-date"),
            key: "lastHireDate",
        },
        {
            name: t("seniority-date"),
            key: "dateOfSeniority",
        },
    ], [t]);
}
